'use strict';

const baseHelper = require('./base-helper');
const { showToastMessage } = require('../components/toast');
const initPopOver = require('../components/initPopOver');
const cartButtonCollection = 'button.add-to-cart, button.add-to-cart-global, button.js-multi-add-to-cart';

/**
 * injects confirmation modal recommendations
 * @param {jQuery} $modal - DOM element modal
 */
function renderConfirmationModalRecommendations($modal) {
    const $recommendationsWrapper = $($modal).find('.js-add-to-cart-confirmation-modal-product-recommendations-wrapper');
    if (!$recommendationsWrapper.length) {
        return;
    }

    const recommendationsUrl = $recommendationsWrapper.data('recommendations-url');
    if (recommendationsUrl) {
        $.ajax({
            url: recommendationsUrl,
            method: 'GET',
            success: function (data) {
                $recommendationsWrapper.html(data);
                initPopOver();
                document.body.dispatchEvent(new CustomEvent('product:tileRendered', { detail: $recommendationsWrapper[0], bubbles: true }));
            },
            error: function () {
                $recommendationsWrapper.empty();
            }
        });
    }
}

/**
 * injects and displays modal
 * @param {string} modalHTML - HTML string of modal
 */
function showConfirmationModal(modalHTML) {
    const modalID = 'addToCartConfirmationModal';
    let $modal = $('#' + modalID);

    if ($modal.length) {
        $modal.modal('hide');
        $modal.remove();
    }

    $('body').append(modalHTML);
    $modal = $('#' + modalID);
    if ($modal.length) {
        renderConfirmationModalRecommendations($modal);
        $modal.modal('show');
    }
}

/**
 * Updates the Mini-Cart quantity value + Confirmation UI after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    if (typeof window.checkResponseForEventDetails === 'function') {
        window.checkResponseForEventDetails(response);
    }

    $('.minicart').trigger('count:update', response);
    if (!response.error) {
        const isCartPage = document.querySelector('.page')?.dataset.action === 'Cart-Show';
        var confirmationModalHTML = response.confirmationModal;

        if (isCartPage) {
            $.spinner().start();
            const url = new URL(window.location.href);
            url.searchParams.set('addtocart', 'success');

            window.location.href = url.toString();
        } else if (confirmationModalHTML) {
            showConfirmationModal(confirmationModalHTML);
        } else {
            showToastMessage({
                message: response.message,
                alertType: 'alert-success'
            });
        }
    }

    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        // Disable Bonus Product Modal Launch below
        // baseHelper.chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (!response.error) {
            return;
        }

        showToastMessage({
            message: response.message,
            alertType: 'alert-danger',
            disableAutoClosing: true
        });
    }
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    var optionsRadio = $productContainer
        .find('.product-option-radio')
        .map(function () {
            var $elRadio = $(this).find('.js-options-radio:checked');
            var selectedValueId = $elRadio.data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    var optionsCombined = options.concat(optionsRadio);

    return JSON.stringify(optionsCombined);
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants.
 * Info stored as data attribute on atc btn (to make it work on both pdp and catalog tiles).
 *
 * @param {Element} addToCartBtn - addToCartBtn
 * @return {string} - List of selected bundle product item ID's
 */
function getChildProducts(addToCartBtn) {
    let attributeKey = 'data-child-products';

    return addToCartBtn.hasAttribute(attributeKey) ? addToCartBtn.getAttribute(attributeKey) : '[]';
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Fires button spinner animation + makes add-to-cart button in DOM disabled until AJAX responds
 *
 */
function showSpinner() {
    function addToCartHandler(_event, eventData) {
        var $addToCartButton = $(eventData);

        $addToCartButton.find('.js-add-to-cart-loader').removeClass('d-none');
        $addToCartButton.find('.js-add-to-cart-icon').addClass('d-none');
        $(cartButtonCollection).prop('disabled', true);
    }

    $('body').on('product:beforeAddToCart product:beforeAttributeSelect', addToCartHandler);
}

/**
 * trigger confirmation modal + minicart update after add-to-cart
 * @param {Object} data - Cart-AddProduct response
 */
function processAddToCartResponse(data) {
    handlePostCartAdd(data);
    $('body').trigger('product:afterAddToCart', data);
    baseHelper.miniCartReportingUrl(data.reportingURL);

    const cartQuantityIndicatorEle = $('.minicart-quantity');
    if (data.quantityTotal) {
        cartQuantityIndicatorEle?.removeClass('d-none');
    } else {
        cartQuantityIndicatorEle?.addClass('d-none');
    }
}

/**
 * Add-to-cart behavior
 *
 */
function addToCart() {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $('body').trigger('product:beforeAddToCart', [$(this)]);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $('.product-detail').each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).data('pid'),
                        qty: $(this).find('.quantity-select').val(),
                        options: getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = baseHelper.getPidValue($(this));

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }

        addToCartUrl = getAddToCartUrl();

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(this),
            configuratorProducts: JSON.stringify($('.configurator-sections').data('configurator-config')),
            lineItemId: $('.configurator-sections').data('line-item-id'),
            quantity: baseHelper.getQuantitySelected($(this))
        };
        var $loader = $(this).find('.js-add-to-cart-loader');
        var $addToCartIcon = $(this).find('.js-add-to-cart-icon');

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    processAddToCartResponse(data);
                    $loader.addClass('d-none');
                    $addToCartIcon.removeClass('d-none');
                    $(cartButtonCollection).prop('disabled', false);
                },
                error: function () {
                    $loader.addClass('d-none');
                    $(cartButtonCollection).prop('disabled', false);
                }
            });
        }
    });
}

function multiAddToCart() {
    $(document).on('click', '.js-multi-add-to-cart', function () {
        var pids;
        try {
            pids = JSON.parse($(this).attr('data-pids'));
        } catch (e) {
            console.error('failed to parse data-pids', e);
            return;
        }

        if (!Array.isArray(pids) || pids.length === 0) {
            console.error('data-pids must be a non-empty array', pids);
            return;
        }

        var addToCartUrl = getAddToCartUrl();
        if (!addToCartUrl) {
            console.error('add-to-cart URL not found');
            return;
        }

        var setPids = pids.map(function (pid) {
            return { pid: pid, qty: 1, options: '[]' };
        });

        var $button = $(this);
        var $loader = $button.find('.js-add-to-cart-loader');
        var $multiAddToCartIcon = $button.find('.js-add-to-cart-icon');

        var form = {
            pid: pids[0],
            pidsObj: JSON.stringify(setPids),
            isThematicProduct: true
        };

        $('body').trigger('product:beforeAddToCart', [$button]);

        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                processAddToCartResponse(data);
                $loader.addClass('d-none');
                $multiAddToCartIcon.removeClass('d-none');
                $(cartButtonCollection).prop('disabled', false);
            },
            error: function () {
                $loader.addClass('d-none');
                $multiAddToCartIcon.removeClass('d-none');
                $(cartButtonCollection).prop('disabled', false);
            }
        });
    });
}

/**
 * trigger confirmation modal + minicart update externally
 */
function externalAddToCart() {
    document.addEventListener('cart:external-added', function (e) {
        if (e.detail) {
            processAddToCartResponse(e.detail);
        }
    });
}

module.exports = {
    showSpinner: showSpinner,
    addToCart: addToCart,
    multiAddToCart: multiAddToCart,
    externalAddToCart: externalAddToCart
};
